import dayjs from 'dayjs'

export const defaultDate = (startTime, endTime) => {
    const isBetween = dayjs().isBetween(startTime, endTime, 'day', '[]')

    if (isBetween) {
       return dayjs()
    }
   return dayjs(endTime)
}